// action types
import { createRequestTypes } from "../../utils";

export const FETCH_RELATED_ARTICLES = createRequestTypes("FETCH_RELATED_ARTICLES");

export const fetchRelatedArticlesRequest = (tag) =>
    ({ type: FETCH_RELATED_ARTICLES.REQUEST, payload: tag });

export const fetchRelatedArticlesSuccess = (articles) =>
    ({ type: FETCH_RELATED_ARTICLES.SUCCESS, payload: articles });

export const fetchRelatedArticlesFailure = (error) =>
    ({ type: FETCH_RELATED_ARTICLES.FAILURE, payload: error });